import { DeleteButton } from "@/components/admin";
import { EditButton } from "@/components/admin/edit-button";
import { ReferenceManyField } from "@/components/admin/reference-many-field";
import { ShowButton } from "@/components/admin/show-button";
import { useRecordContext } from "ra-core";

import { AsideSection } from "../misc/AsideSection";
import { AddTask } from "../tasks/AddTask";
import { TasksIterator } from "../tasks/TasksIterator";
import type { Contact } from "../types";
import { ContactBackgroundInfo } from "./ContactBackgroundInfo";
import { ContactMergeButton } from "./ContactMergeButton";
import { ContactPersonalInfo } from "./ContactPersonalInfo";
import { ConvertLeadToEnquiryButton } from "./ConvertLeadToEnquiryButton";
import { ExportVCardButton } from "./ExportVCardButton";
import { TagsListEdit } from "./TagsListEdit";

export const ContactAside = ({ link = "edit" }: { link?: "edit" | "show" }) => {
  const record = useRecordContext<Contact>();

  if (!record) return null;
  return (
    <div className="hidden sm:block w-92 min-w-92 text-sm">
      <div className="mb-4 -ml-1">
        {link === "edit" ? (
          <ShowButton label="View Contact" />
        ) : (
          <EditButton label="Edit Contact" />
        )}
        {link !== "edit" && <div className="mt-2"><ConvertLeadToEnquiryButton /></div>}
      </div>

      <AsideSection title="Personal info">
        <ContactPersonalInfo />
      </AsideSection>

      <AsideSection title="Background info">
        <ContactBackgroundInfo />
      </AsideSection>

      <AsideSection title="Tags">
        <TagsListEdit />
      </AsideSection>

      <AsideSection title="Tasks">
        <ReferenceManyField
          target="contact_id"
          reference="tasks"
          sort={{ field: "due_date", order: "ASC" }}
        >
          <TasksIterator />
        </ReferenceManyField>
        <AddTask />
      </AsideSection>

      {link !== "edit" && (
        <>
          <div className="mt-6 pt-6 border-t hidden sm:flex flex-col gap-2 items-start">
            <ExportVCardButton />
            <ContactMergeButton />
          </div>
          <div className="mt-6 pt-6 border-t hidden sm:flex flex-col gap-2 items-start">
            <DeleteButton
              className="h-6 cursor-pointer hover:bg-destructive/10! text-destructive! border-destructive! focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40"
              size="sm"
            />
          </div>
        </>
      )}
    </div>
  );
};
